import React, { Component } from "react";
import axios from "axios";
import {
  numberWithCommasAndSpace,
  setUserSessionAuthKey
} from "../../Component/commonUtils";
import logo from "../../Assests/RebelSkool.png";
import { Image } from "primereact/image";
import { Fieldset } from "primereact/fieldset";
import { Link } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { FcApproval } from "react-icons/fc";
import { Divider } from "primereact/divider";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import config from "../../Configuration/Config";
import ConfettiExplosion from "react-confetti-explosion";
import TranslationFile from "../15-Translation/locale/Translation_apps.json";
import PaymentConfirmationDone from "../../Assests/PaymentConfirmationDone.gif";
import PaymentConfirmationLoading from "../../Assests/PaymentConfirmationLoading.gif";
import PaymentDeclined from "../../Assests/PaymentDeclined.gif";

let userSelectedLanguage = localStorage.getItem("selectedLanguage");
let userSessionAuthKeyReturnValue = setUserSessionAuthKey();
let navigationURL, navigationTarget;
let splittedUrl = window.location.href.split("/");
let currentReportGUIDFromUrl = splittedUrl[splittedUrl.length - 2];
let currentAppNameFromUrl = splittedUrl[splittedUrl.length - 3];
const annualReport = "/annualreport/";
currentAppNameFromUrl = "/" + currentAppNameFromUrl + "/";
class PaymentConfirmation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      detailsText: "",
      showBox: false,
      isExploding: false,
      paymentDecline: false,
      paymentID: "",
      purchaseID: ""
      // readyToShipDateTime: "",
    };
  }

  componentWillMount() {
    splittedUrl = window.location.href.split("/");
    currentReportGUIDFromUrl = splittedUrl[splittedUrl.length - 2];

    window.scrollTo(0, 0);
    userSelectedLanguage = localStorage.getItem("selectedLanguage");
    let localData = localStorage.getItem("rebelSkoolUser");
    let localObject = "";
    if (localData != "undefined") {
      localObject = JSON.parse(localData);
    }

    const userGUID =
      localObject && localObject.userGUID
        ? localObject.userGUID
        : currentReportGUIDFromUrl;

    if (userSessionAuthKeyReturnValue) {
      const config = {
        headers: {
          "User-Session-Auth-Key":
            userSessionAuthKeyReturnValue.headers["User-Session-Auth-Key"],
          language: userSelectedLanguage
        }
      };
      axios
        .get("/nets/getCheckout?reportGUID=" + currentReportGUIDFromUrl, config)
        .then((response) => {
          if (response.data !== "") {
            let taxRate = 0.25;
            let exMomsValue = response.data.totalPrice / (1 + taxRate);
            let momsValue = response.data.totalPrice - exMomsValue;
            this.setState({ showBox: true, isExploding: true });
            this.setState({ isLoading: false });

            let dateString = response.data.readyToShipDateTime;
            let date = new Date(dateString);
            // Extract components
            let year = date.getFullYear();
            let month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
            let day = String(date.getDate()).padStart(2, "0");
            let hours = String(date.getHours()).padStart(2, "0");
            let minutes = String(date.getMinutes()).padStart(2, "0");
            let seconds = String(date.getSeconds()).padStart(2, "0");

            // Combine to "YYYY-MM-DD HH:MM:SS" format
            let formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

            this.setState({
              paymentID: response.data.paymentId,
              purchaseID: response.data.chargeId,
              paymentPlatform: response.data.paymentMethod == 0 && "Nets Easy",
              totalIncMoms: response.data.totalPrice,
              moms: Math.floor(momsValue * 100) / 100,
              totalExMoms: exMomsValue.toFixed(2),
              invoiceSentEmail: response.data.emailId,
              readyToShipDateTime: formattedDate
            });
          } else {
            this.setState({ showBox: true, isExploding: true });
            this.setState({ detailsText: "Redirecting to Next Page" });
            setTimeout(() => {
              this.navigateAfterPayment();
            }, 2000);
          }
        })
        .catch((error) => {
          this.setState({
            paymentDecline: true
          });
          // this.toast.show({
          //   severity: "error",
          //   summary: "Payment is unsuccessful",
          //   detail: "... Redirecting to Home",
          //   life: 2000,
          // });
          setTimeout(() => {
            // this.props.history.push(reverseNavigationUrl);
            this.props.history.push("/");
          }, 5000);
        });
    }
    if (userSessionAuthKeyReturnValue) {
      axios
        .get(
          "/annualReport/getHeader?reportId=" + currentReportGUIDFromUrl,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {
          if (response.data != "" && response.data != null) {
            localStorage.setItem("cartValues", []);

            if (response.data.reportID == null) {
              navigationURL = "/" + userGUID + "/MyProfile";
              navigationTarget = "MyProfile";
              this.setState({
                navigateBtnLabel:
                  TranslationFile.GoToMyProfile[userSelectedLanguage]
              });
            } else {
              navigationURL =
                annualReport + currentReportGUIDFromUrl + "/reviewAndSend";
              navigationTarget = "reviewAndSend";
              this.setState({
                navigateBtnLabel:
                  TranslationFile.GoToReviewAndSend[userSelectedLanguage]
              });
            }
          }
        });
    }
  }

  navigateAfterPayment() {
    this.props.history.push(navigationURL);
  }

  handleLinkClick(e) {
    e.preventDefault();
    const href = e.currentTarget.getAttribute("href");
    window.location.href = href;
  }

  render() {
    const { totalExMoms, moms, totalIncMoms, paymentID, purchaseID } =
      this.state;
    return (
      <div className="forgot-password-main-div">
        <Toast
          ref={(el) => {
            this.toast = el;
          }}
          style={{ marginTop: "80px" }}
        ></Toast>
        <div>
          <div className="paymentConfirmation-container">
            <div className="mand-bill-info" style={{ marginTop: "2%" }}>
              <center>
                <i
                  className="pi pi-info-circle"
                  style={{ marginRight: "5px" }}
                ></i>
                <span style={{ marginRight: "2px" }}>
                  {/* Please Don't go back or refresh this page */}
                  {TranslationFile.refreshthispageText[userSelectedLanguage]}
                </span>
              </center>
            </div>
            <center>
              <div className="forget-password-logo" style={{ margin: "10px" }}>
                {/* <Link onClick={(e) => this.handleLinkClick(e)}>
                  <Image src={logo} alt="Image" width="200" />
                </Link> */}
                <a href="/annualreport" onClick={this.handleLinkClick}>
                  <Image
                    src={logo}
                    alt="Image"
                    className="corp-navbar-logo"
                    width="200"
                  />
                </a>
              </div>
            </center>

            {this.state.paymentDecline && (
              <div className="paymentConfimationLoadingGif">
                {/* <i
                  className="pi pi-spin pi-spinner"
                  style={{ fontSize: "2rem" }}
                ></i> */}
                <img
                  src={PaymentDeclined}
                  alt="loading..."
                  style={{
                    width: "12em",
                    height: "12em",
                    marginTop: "-12em"
                  }}
                  className="companyInfoProceedSpinner"
                />
                <p>
                  <i>
                    {TranslationFile.paymentUnsuccessfull[userSelectedLanguage]}
                  </i>
                </p>
              </div>
            )}

            {this.state.isLoading ? (
              <div className="paymentConfimationLoadingGif">
                {/* <i
                  className="pi pi-spin pi-spinner"
                  style={{ fontSize: "2rem" }}
                ></i> */}
                <img
                  src={PaymentConfirmationDone}
                  alt="loading..."
                  style={{
                    width: "12em",
                    height: "12em",
                    marginTop: "-12em"
                  }}
                  className="companyInfoProceedSpinner"
                />
              </div>
            ) : (
              <Fieldset
                legend={
                  this.state.detailsText != ""
                    ? this.state.detailsText
                    : this.state.isLoading
                      ? "Payment Processing.. Please Wait"
                      : TranslationFile.PaymentConfirmationHeader[
                          userSelectedLanguage
                        ]
                }
              >
                <center>
                  <ConfettiExplosion />
                </center>
                <div>
                  {this.state.isLoading || !this.state.showBox ? (
                    <div className="paymentConfimationLoadingGif">
                      <center>
                        <img
                          src={PaymentConfirmationDone}
                          alt="loading..."
                          style={{
                            width: "12em",
                            height: "12em",
                            marginTop: "-12em"
                          }}
                          className="companyInfoProceedSpinner"
                        />
                      </center>
                      <br></br>
                    </div>
                  ) : (
                    <div>
                      <center className="PC-Info">
                        {TranslationFile.Paymentsuccess[userSelectedLanguage]}
                      </center>
                      <center>
                        {/* <FcApproval style={{ fontSize: "5rem" }} /> */}

                        <img
                          src={PaymentConfirmationDone}
                          alt="loading..."
                          style={{
                            width: "5em",
                            height: "5em"
                          }}
                        />
                      </center>
                      <div
                        style={{ textAlign: "left" }}
                        className="payment-info-div"
                      >
                        {paymentID != "" && purchaseID != "" && (
                          <>
                            <Divider />
                            <Row>
                              <Col className="PC-Info">
                                {" "}
                                {
                                  TranslationFile.PaymentIDText[
                                    userSelectedLanguage
                                  ]
                                }
                              </Col>
                              <Col>{this.state.paymentID}</Col>
                            </Row>
                            <Divider />
                            <Row>
                              <Col className="PC-Info">
                                {" "}
                                {
                                  TranslationFile.PurchaseIDText[
                                    userSelectedLanguage
                                  ]
                                }
                              </Col>
                              <Col>{this.state.purchaseID}</Col>
                            </Row>

                            <Divider />
                            <Row>
                              <Col className="PC-Info">
                                {
                                  TranslationFile.PurchasePlatformText[
                                    userSelectedLanguage
                                  ]
                                }
                              </Col>
                              <Col>{this.state.paymentPlatform}</Col>
                            </Row>
                          </>
                        )}

                        {/* <Divider />
                        <Row>
                          <Col className="PC-Info">
                            {
                              TranslationFile.PurchasePlatformText[
                                userSelectedLanguage
                              ]
                            }
                          </Col>
                          <Col>{this.state.paymentPlatform}</Col>
                        </Row> */}
                        <Divider />
                        <Row>
                          <Col className="PC-Info">
                            {TranslationFile.TotalExMoms[userSelectedLanguage]}
                          </Col>
                          <Col>
                            {totalExMoms != undefined
                              ? numberWithCommasAndSpace(totalExMoms)
                              : ""}
                            kr
                          </Col>
                        </Row>
                        <Divider />
                        <Row>
                          <Col className="PC-Info">
                            {TranslationFile.MomsText[userSelectedLanguage]}
                          </Col>
                          <Col>
                            {moms != undefined
                              ? numberWithCommasAndSpace(moms)
                              : ""}{" "}
                            kr
                          </Col>
                        </Row>
                        <Divider />
                        <Row>
                          <Col className="PC-Info">
                            {
                              TranslationFile.TotalIncMomsText[
                                userSelectedLanguage
                              ]
                            }
                          </Col>
                          <Col>
                            {totalIncMoms != undefined
                              ? numberWithCommasAndSpace(totalIncMoms)
                              : ""}{" "}
                            kr
                          </Col>
                        </Row>
                        <Divider />
                        <Row>
                          <Col className="PC-Info">
                            {
                              TranslationFile.TransactionDateText[
                                userSelectedLanguage
                              ]
                            }
                          </Col>
                          <Col>{this.state.readyToShipDateTime}</Col>
                        </Row>
                        <Divider />

                        <Row>
                          <Col className="PC-Info">
                            {
                              TranslationFile.urInvoiceSendtoText[
                                userSelectedLanguage
                              ]
                            }{" "}
                            <span className="PC-invoice-mail">
                              {this.state.invoiceSentEmail}
                            </span>
                          </Col>
                        </Row>

                        <Divider />
                        <center>
                          <Link
                            to={navigationURL && { pathname: navigationURL }}
                            target="_self"
                          >
                            <Button
                              label={this.state.navigateBtnLabel}
                              icon="pi pi-arrow-right"
                              iconPos="right"
                            />
                          </Link>
                        </center>
                      </div>
                    </div>
                  )}
                </div>
              </Fieldset>
            )}
          </div>
        </div>
      </div>
    );
  }
}
export default PaymentConfirmation;
